import { ChangeOrderForm, ChangeOrderStatus, ChangeOrderType } from 'interfaces/ChangeOrderForm';

import { PAC } from "../../../../data/BusinessConstants";

export const ChangeOrderWizardStep = {
  GeneralInformation: 0,
  QuoteUpload: 1,
  AdditionalFiles: 2
};

export const NEW_CHANGE_ORDER_FORM: ChangeOrderForm = {
  status: ChangeOrderStatus.DRAFT,
  changeOrderType: ChangeOrderType.RFQ,
  changeOrderId: '',
  rfqResponseId: '',
  rfqRevision: 0,
  businessId: PAC,
  generalInformation: {
    description: '',
    poIds: [''],
    fbns: [''],
    reasonForChange: '',
    otherReasonForChange: '',
    requesterEmail: '',
    workPerformed: false,
    osdImpact: false,
    osdImpactComments: ''
  },
  documents: {
    quoteFile: undefined,
    additionalFiles: [],
  }
}
